var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-box"},[_c('van-nav-bar',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"sign_out",attrs:{"slot":"right"},on:{"click":_vm.logout},slot:"right"},[_vm._v("退出登录")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }